import {
  Schedule,
  CheckCircle,
  Error,
  Warning,
  LocalShipping,
  Cancel,
} from "@mui/icons-material";

export type OrderStatusColor =
  | "success"
  | "primary"
  | "warning"
  | "error"
  | "default";

export function getStatusColor(status: string): OrderStatusColor {
  switch (status) {
    case "delivered":
      return "success";
    case "assigned":
    case "picked_up":
    case "arriving":
      return "primary";
    case "at_pickup":
      return "warning";
    case "searching":
      return "error";
    case "cancelled":
      return "default";
    default:
      return "default";
  }
}

export function getStatusIcon(status: string): React.ReactElement {
  switch (status) {
    case "delivered":
      return <CheckCircle />;
    case "assigned":
      return <Schedule />;
    case "at_pickup":
      return <Warning />;
    case "picked_up":
    case "arriving":
      return <LocalShipping />;
    case "searching":
      return <Error />;
    case "cancelled":
      return <Cancel />;
    default:
      return <Schedule />;
  }
}
